/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getDownMedia } from '../../styles';
import { Icon as DefIcon } from '../../components/alert-modals/Icon';
import { Text as DefText } from '../../components/alert-modals/Text';
import { Title } from '../../components/alert-modals/Title';
import { Button as DefButton } from '../../components/buttons';
import { AuthLayout } from '../../layouts';
import { removeSpecificSavedURLParams } from '../../utils/saved-url-params.ts';
import { portfolioUpdateExpiredQueryParams } from '../consts.ts';
import { paths } from '../paths';

const RebalanceExpiredLoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Remove because it has been shown here already
  useEffect(() => {
    removeSpecificSavedURLParams(portfolioUpdateExpiredQueryParams);
  }, []);

  return (
    <Wrapper>
      <Icon type={'error'} />
      <Title>{t('REBALANCE_EXPIRED_LOGIN_PAGE__title')}</Title>
      <Text>{t('REBALANCE_EXPIRED_LOGIN_PAGE__desc1')}</Text>
      <Text>{t('REBALANCE_EXPIRED_LOGIN_PAGE__desc2')}</Text>
      <Button variant={'contained'} onClick={() => navigate(paths.login)}>
        {t('REBALANCE_EXPIRED_LOGIN_PAGE__button')}
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled(AuthLayout)`
  position: relative;
  padding-left: 96px;
  padding-right: 96px;

  ${getDownMedia('sm')} {
    padding-left: 34px;
    padding-right: 34px;
  }
`;

const Icon = styled(DefIcon)`
  ${getDownMedia('sm')} {
    margin-top: 50px;
  }
`;

const Text = styled(DefText)`
  text-wrap: balance;
  margin-left: 0;
  margin-right: 0;
`;

const Button = styled(DefButton)`
  width: 100%;
  margin-top: 20px;
`;

export { RebalanceExpiredLoginPage };
